module.exports = __webpack_public_path__ + "img/node-super.d71af86d.png";